import { LS_ORG_ID_KEY } from '@constants/localStorageKeys';

export const getOrgId = () => localStorage.getItem(LS_ORG_ID_KEY) || '';
